function addMultipleToCartAndOpenDrawer(itemsArray) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ items: itemsArray })
  })
  .then(response => response.json())
  .then(data => {
    // Refresh mini cart contents (if needed)
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

    // Optional: open cart drawer with content
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.renderContents === 'function') {
      cartNotification.renderContents(data);
    }

    // Now trigger the refresh of cart drawer after delay
    $(".btn.solid.add-custom-product.enabled[data-add-to-cart]").addClass("disabled").removeClass("enabled").find('span').text("Added to Bag!");
    $(".btn.solid.add-custom-product[data-add-to-cart] .loading__spinner").addClass("hidden");
    setTimeout(function () {
      const this_cartDrawer = document.querySelector('cart-drawer');
      if (this_cartDrawer && typeof this_cartDrawer.refresh === 'function') {
        this_cartDrawer.refresh(true);
      }
    }, 400);
  })
  .catch(error => {
    $(".btn.solid.add-custom-product[data-add-to-cart] .loading__spinner").addClass("hidden");
    console.error('Error adding multiple products:', error);
  });
}
$(document).on('click','.btn.solid.add-custom-product.enabled[data-add-to-cart]',function(){
    // var variantArray = [];
  
    // $('.configurator-v2__builder-step__option.notshouldshown.selected').each(function() {
    //     var variantId = $(this).attr('data-variant-id');
    //     if (variantId) {
    //         variantArray.push({
    //             id: variantId,
    //             quantity: 1
    //         });
    //     }
    // });
    var variantArray = [];
    $('.configurator-v2__builder-step__option.selected').each(function() {
      $(".btn.solid.add-custom-product.enabled[data-add-to-cart] .loading__spinner").removeClass("hidden");
      var variantId = $(this).attr('data-variant-id');
      console.log(variantId);
      if (variantId != 'null') {
        variantArray.push({
            id: variantId,
            quantity: 1
        });
      }
    });
  
  console.log(variantArray);
    addMultipleToCartAndOpenDrawer(variantArray);
});